import React from 'react'
import EtTrinityWebCelebrateExcellenceLog from './celebrate/EtTrinityWebCelebrateExcellenceLog'
import EtTrinityWebCelebratePerformanceLog from './celebrate/EtTrinityWebCelebratePerformanceLog'
import EtTrinityWebCelebrateMagicLog from './celebrate/EtTrinityWebCelebrateMagicLog'

const EtTrinityWebLandingCelebration = ({ username, userId, userOrgId }) => {
  // Author - Atul Pandey
  // First Created - 09 Apr 2025
  // Purpose to act as the home page for Trinity Landing - Celebrate Home

  return (
    <div className="px-4 md:px-8 pt-6 pb-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Column 1: Excellence Log */}
        <div className="col-span-1">
          <EtTrinityWebCelebrateExcellenceLog 
            username={username}
            userId={userId}
            userOrgId={userOrgId}
          />
        </div>

        {/* Column 2: Performance Log */}
        <div className="col-span-1">
          <EtTrinityWebCelebratePerformanceLog 
            username={username}
            userId={userId}
            userOrgId={userOrgId}
          />
        </div>

        {/* Column 3: Unleashed Magic Log */}
        <div className="col-span-1">
          <EtTrinityWebCelebrateMagicLog 
            username={username}
            userId={userId}
            userOrgId={userOrgId}
          />
        </div>
      </div>
    </div>
  )
}

export default EtTrinityWebLandingCelebration
